import { Component, Input } from "@angular/core";
import { NgwWowService } from "ngx-wow";

@Component({
  moduleId: module.id,
  selector: "pageheader",
  templateUrl: "pageheader.component.html",
  styleUrls: ["pageheader.component.scss"],
})
export class PageHeaderComponent {
  @Input() headerName: string;
  @Input() headerTitle: string;
  constructor(private wowService: NgwWowService) {
    this.wowService.init();
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/pageheader.component.ts